import { Vestiging } from "@/entities/vestiging";
import { createColumnHelper } from "@tanstack/react-table";
import { NameCol, OpeningHoursCol } from "../../shared";
import type { FaciliteitenTableFeatures } from "../../shared/faciliteiten-table-features";
import { BadgeCol, MenuCol } from "./columns";

export type Handlers = {
    onUpdateOpeningstijd: (vestiging: Vestiging, openTot: string) => Promise<void>;
};

type SelectionState = {
    onVestigingenSelectionChange: (vestigingId: number, selected: boolean) => void;
    vestigingenIdSelection: number[];
};

export const createColumns = (selectionState: SelectionState, handlers: Handlers) => {
    const columnHelper = createColumnHelper<FaciliteitenTableFeatures, Vestiging>();
    return columnHelper.columns([
        columnHelper.accessor("beheerVestiging.vestigingNaam", {
            cell: ({ row }) => (
                <NameCol
                    variant="nieuweAanvraagRegievoerder"
                    vestiging={row.original}
                    isSelected={selectionState.vestigingenIdSelection.includes(row.original.beheerVestiging.id)}
                    onSelectionChange={selectionState.onVestigingenSelectionChange}
                />
            ),
        }),
        columnHelper.accessor("currentOpeningstijden", {
            cell: ({ row }) => <OpeningHoursCol variant="nieuweAanvraagRegievoerder" vestiging={row.original} />,
        }),
        columnHelper.display({
            id: "badge",
            cell: ({ row }) => <BadgeCol vestiging={row.original} />,
        }),
        columnHelper.display({
            id: "menu",
            cell: ({ row }) => <MenuCol vestiging={row.original} onUpdateOpeningstijd={handlers.onUpdateOpeningstijd} />,
        }),
    ]);
};
